import axios from 'axios';

const axiosInstance = axios.create({
    withCredentials: true
});

let authenticated;
let userId;
let instituteEnabled;

const sleep = () => new Promise((res) => { setTimeout(res, 100) })

const initAuth = (process.env.NODE_ENV === 'development') ?
    async (onAuth) => {
        await sleep();
        authenticated = true;
        userId = '465d2582-ec40-4aee-8a78-902252d44997';
        instituteEnabled = true;
        onAuth();
    }
    :
    async (onAuth) => {
        try {
            const res = await axiosInstance('/api/auth/whoami');
            authenticated = true;
            userId = res.data.id;
            instituteEnabled = res.data.instituteEnabled;
            onAuth();
        } catch (ex) {
            window.location.replace('/api/auth/login');
        }
    };

const logout = () => {
    window.location.replace('/api/auth/logout');
}

const UserService = {
    initAuth,
    logout,
    isLoggedIn: () => authenticated,
    getUserId: () => userId,
    isInstituteEnabled: () => instituteEnabled,
};

export default UserService;
